class SecureKeyManager {
  private static instance: SecureKeyManager | null = null

  // 由同级GeneratedKey.js生成的密钥片段
  private readonly KEY_PARTS = [
    ['s', 'u', '1', '0'],
    ['o', '1', 'x', '0'],
    ['y', 's', 'x', 'r'],
    ['0', 'u', 'q', 'n'],
    ['v', '0', 'r', 'z'],
    ['n', 'r', 't', 'z'],
  ]

  private readonly REVERSE_MAP: Record<string, string> = {
    m: '0',
    n: '1',
    o: '2',
    p: '3',
    q: '4',
    r: '5',
    s: '6',
    t: '7',
    u: '8',
    v: '9',
    w: 'a',
    x: 'b',
    y: 'c',
    z: 'd',
    '0': 'e',
    '1': 'f',
    '2': 'g',
    '3': 'h',
    '4': 'i',
    '5': 'j',
    '6': 'k',
    '7': 'l',
    '8': 'm',
    '9': 'n',
    a: 'o',
    b: 'p',
    c: 'q',
    d: 'r',
    e: 's',
    f: 't',
    g: 'u',
    h: 'v',
    i: 'w',
    j: 'x',
    k: 'y',
    l: 'z',
  }

  public static getInstance(): SecureKeyManager {
    if (SecureKeyManager.instance === null) {
      SecureKeyManager.instance = new SecureKeyManager()
    }
    return SecureKeyManager.instance
  }

  async getSecretKey(): Promise<string> {
    try {
      const key = this.reconstructKey()
      return key
    } catch (error) {
      console.warn('字符重构失败', error)
    }

    return 'key_error'
  }

  private reconstructKey(): string {
    const originalParts = this.KEY_PARTS.map((part) => {
      return part
        .map((char) => {
          const originalChar = this.REVERSE_MAP[char]
          if (!originalChar) {
            console.warn(`字符 ${char} 无法反向映射`)
            return char
          }
          return originalChar
        })
        .join('')
    })

    return originalParts.join('')
  }
}

export const secureKeyManager = SecureKeyManager.getInstance()
